<template>
	<div class="google-map-component">
		<div class="google-map" :id="mapName"></div>
	</div>
</template>

<script>
import uniqueid from '@/utils/uniqueid'
import { MAP_MODE_SINGLE, MAP_MODE_MULTI, MAP_MODE_ZONE } from '@/utils/maps'
import GoogleMapsLoader from 'google-maps'
export default {
	name: 'google-map-simple',
	props: {
		lat: {
			type: Number,
			default: 41.5518368
		},
		lng: {
			type: Number,
			default: -8.4242315
		},
		mode: {
			type: Number,
			default: MAP_MODE_SINGLE
		},
		mapOptions: {
			type: Object,
			default: () => {
				return {
					zoom: 16
				}
			}
		}
	},
	data () {
		return {
			map: null,
			geocoder: null,
			marker: null
		}
	},
	computed: {
		mapName () {
			return `google-map-${uniqueid()}`
		}
	},
	methods: {
		isMode (mode) {
			return this.mode === mode
		},
		setupMap () {
			// get element and create map
			const element = document.getElementById(this.mapName)
			if (element === null) {
				this.$log.error('google map', 'setupMap() ERROR', 'element is null')()
				return false
			}
			const options = {
				center: new google.maps.LatLng(0, 0),
				...this.mapOptions
			}
			this.map = new google.maps.Map(element, options)

			// minimum zoom when bounds are small
			google.maps.event.addListenerOnce(this.map, 'bounds_changed', () => {
				this.map.setZoom(Math.min(this.mapOptions.zoom, this.map.getZoom()))
			})
			this.setupGeocoder()
			this.setupMarkers()
		},
		setupGeocoder() {
			this.geocoder = new google.maps.Geocoder;

			const position = new google.maps.LatLng({lat: this.lat, lng: this.lng})
			this.geocoder.geocode({'location': position}, (results, status) => {
				if (status === 'OK') {
					this.$emit('street', results[0].formatted_address)
				}
			});
		},
		setupMarkers () {
			// clear previous
			if (this.marker) {
				this.marker.setMap(null)
			}

			// create marker
			const icon = {
				url: '/static/svg/maps/circle-main.svg',
				size: new google.maps.Size(40, 40),
				origin: new google.maps.Point(0, 0),
				anchor: new google.maps.Point(20, 20),
				scaledSize: new google.maps.Size(40, 40)
			}
			const position = new google.maps.LatLng({lat: this.lat, lng: this.lng})
			this.marker = new google.maps.Marker({
				position: position,
				icon: icon,
				title: `lat: ${this.lat} lng: ${this.lng}`,
				map: this.map
			})
			const bounds = new google.maps.LatLngBounds()
			bounds.extend(position)
			this.map.fitBounds(bounds)
		},
	},
	mounted () {
		GoogleMapsLoader.KEY = this.$root.settings.googleMapsKey
		GoogleMapsLoader.LIBRARIES = this.$root.settings.googleMapsLibraries
		GoogleMapsLoader.load(() => {
			this.setupMap()
		})
	}
}
</script>

<style scoped>
.google-map-component {
	width: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/maps/GoogleMapSimple.vue